import { render, staticRenderFns } from "./CreateAssetsFailCard.vue?vue&type=template&id=0b1e2c98&scoped=true&"
import script from "./CreateAssetsFailCard.vue?vue&type=script&lang=js&"
export * from "./CreateAssetsFailCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssetsFailCard.vue?vue&type=style&index=0&id=0b1e2c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e2c98",
  null
  
)

export default component.exports